
  import { Vue, Component, Prop } from "vue-property-decorator";
  import TagLabel from "@/components/projects/Tags/TagLabel.vue";

  @Component({
    components: {
      TagLabel,
    },
  })
  export default class SkillMultiselectItem extends Vue {
    @Prop({ type: String, required: true }) readonly tagName!: string;
    @Prop({ type: String, required: true }) readonly labelText!: string;
  }
